import SalesForm from './SalesForm';

export default SalesForm;
